import { useMeasure } from "react-use";
import WeeklyDowntimeTrend from "../Charts/WeeklyDowntimeTrend";
import { PAGE_WIDTH_FOR_PRINT_PCI } from "../../../../../constants/constants";
import {
  DateAndDataDumpType,
  PciChartDataType,
  pnlCategoriesData,
} from "../../../../../types";

import PlannedDowntimePerShift from "../Charts/PlannedDowntimePerShift";
import DowntimePareto from "../Charts/DowntimePareto";
import { THIRD_OF_PAGE } from "./PciPerformanceReport";

export default function DowntimeReports({
  completedYearlyData,
  currentWeekNumber,
  shiftsDataArray,
  filteredtotalTimePerTagLastWeekData,
  lastWeeksWeeklyResults,
  shouldSetWidth = false,
}: {
  completedYearlyData: PciChartDataType[] | null;
  currentWeekNumber: number;
  shiftsDataArray: PciChartDataType[] | null;
  filteredtotalTimePerTagLastWeekData: pnlCategoriesData[] | null;
  lastWeeksWeeklyResults: DateAndDataDumpType | null;
  shouldSetWidth?: boolean;
}) {
  console.log("Using measure DowntimeReports");
  const [ref, { width }] = useMeasure<HTMLDivElement>();
  return (
    <div ref={ref} className="reportBody">
      <PlannedDowntimePerShift
        data={shiftsDataArray}
        width={shouldSetWidth ? PAGE_WIDTH_FOR_PRINT_PCI : width}
        height={THIRD_OF_PAGE}
      />
      <WeeklyDowntimeTrend
        data={completedYearlyData}
        width={shouldSetWidth ? PAGE_WIDTH_FOR_PRINT_PCI : width}
        height={THIRD_OF_PAGE}
        showPlanned={true}
      />
      <DowntimePareto
        data={filteredtotalTimePerTagLastWeekData}
        date={lastWeeksWeeklyResults?.date}
        width={shouldSetWidth ? PAGE_WIDTH_FOR_PRINT_PCI : width}
        height={THIRD_OF_PAGE}
      />
    </div>
  );
}
